// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"9064b354","251":"afe1c0e7","348":"1a909319","364":"9250bcb5","571":"ef2a3211"}[chunkId] + ".chunk.js";
};